<template>
  <div class="about">
    <h1 class="mw-h1">About</h1>
  </div>
</template>
<script>
	export default {
		name: "About",
		
	}
</script>